// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__tJ585","stores":"App_stores__NpcYj","small":"App_small__001jb","big":"App_big__6kFAu","content":"App_content__H7Y49","text":"App_text__NIw_B"};